<template>
    <div v-if="messageVisible && admin" class="admin-view">
        <p>You are viewing as a White Label Admin <a href="#" v-on:click.prevent="closeMessage" class="close">&times;</a></p>
    </div>
</template>

<script>
    export default {
        name: 'admin-message',

        props: {
            admin: {
                type: Boolean,
            },
        },

        data() {
            return {
                messageVisible: true,
            }
        },

        methods: {
            closeMessage() {
                this.messageVisible = false;
            }
        }
    }
</script>
